<template>
    <div class="project">
        <div class="project-details">
            <h3 class="name">
                {{name}}
            </h3>
            <div class="members">
                <slot name="members"></slot>
            </div>
        </div>
        <div class="image" :style="{ 'background-image': `url(${imageSrc})` }"></div>
        <div class="description">
            <slot name="description"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "project-details",
        props: {
            name: {
                type: String,
                required: true
            },
            imageSrc: {
                type: String,
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .project {
        border-left: 2px solid $entelect-orange;
        padding: 4px 0 4px 24px;
        margin-bottom: 16px;

        position: relative;
        display: grid;
        grid-template-rows: auto 200px auto;
        grid-template-areas: 'details' 'image' 'description';
        grid-gap: 16px;
        grid-auto-flow: column;

        &:before {
            position: absolute;
            content: '';
            top: 0;
            bottom: 0;
            left: -16px;
        }

        .project-details {
            grid-area: details;

            .name {
                color: $entelect-orange;
            }

            .members {
                color: $green;
                font-weight: bold;
                font-size: 14px;
            }
        }

        .image {
            grid-area: image;
            background: no-repeat center;
            background-size: cover;
        }

        .description {
            grid-area: description;
            text-align: justify;
        }
    }
</style>